<template>
  <div class="row">
    <div style="background-color: #aaffff" class="col-md-12 pt-3 my-3 border text-body">
      <h4 align="center"><font size="5">Estimating the time-varying reproduction number of COVID-19 with a state-space method.</font></h4>
      <p align="center"><font size="2">Web-application developed by Hidetaka Manabe, Shinsuke Koyama, and Shigeru Shinomoto (Kyoto University)</font></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Head'
}
</script>

<style>
</style>